module.exports = __webpack_public_path__ + "static/media/player2-button.43b49e62.png";